<template>  
    <section class="blockElement loginLoader-page">
        <app-loader-component :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></app-loader-component>
        <div class="container-fluid bglogin p-0">
            <div class="innerInclude">
                <div class="p_login d-flex align-items-center justify-content-center p-0">
                    <div class="row w-100">
                        <div class="col-12 col-md-12 text-center d-flex vh_100 align-items-center bodyBG">
                            <div class="sign_insec text-center">
                                <div class="subtitle">
                                    <img src="../../../../static/fxView/images/fxview_logo.svg" alt="Logo">
                                    <h3>Sign in</h3>
                                    <p class="alert alert-danger" v-if="message != ''">{{message}}</p>
                                </div>
                                <div class="stepForm">
                                    <div class="form-group field-wrapper">
                                        <input placeholder=" " type="text" v-model="email" name="email" class="float-field form-control"  v-validate="'required|email'"   :class="{ 'is-invalid': submitted && errors.has('email') }" ref="emailInput"/>
                                        <label class="float-label">Email</label>
                                        <p v-for="error in errors.collect('email')" class="error">{{ error }}</p>
                                        <feather type="mail" class="mailTo"></feather>
                                    </div>
                                    <div class="form-group field-wrapper">
                                        <input placeholder=" " :type="inputtype" v-model="password" name="password" class="float-field form-control" v-validate="'required'"   :class="{ 'is-invalid': submitted && errors.has('password') }" ref="passwordInput" v-on:keyup.enter="login" />
                                        <label class="float-label">Password</label>
                                        <feather :type="iconType" class="mailTo" @click="switchVisibility"></feather>
                                        <p v-for="error in errors.collect('password')" class="error">{{ error }}</p>
                                    </div>
                                    <div class="signupbtn full-width submitButton w-100">
                                        <button class="prism_btn w-100" v-on:click="login()">LOGIN </button>
                                    </div>
                                     
                                </div>            
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    import * as types from '@/types'
    import { mapActions } from 'vuex'  
    export default {
        name: 'LOGIN',
        mixins: [fxViewMixins],
        data(){     
            return {
                email:"",
                password:"",  
                message : '',
                message_type : '',          
                pageLoader : false,
				submitted : false,
				showpassword : false,
				iconType : 'eye-off',
                inputtype : 'password'
            }
        },
        methods:{
            ...mapActions({
                _runLogin: types.RUN_USER_LOGIN
            }),
			switchVisibility() {
                this.showpassword = !this.showpassword
                if(this.showpassword){
                    this.inputtype = 'text'
                    this.iconType = 'eye'
                }else{
                    this.inputtype = 'password'
                    this.iconType = 'eye-off'
                } 
            },
            login(){
                const _that = this
				_that.submitted = true;
				_that.$validator.validate().then(valid => {
                    if (valid) {
                        let inputJson={
                            'globalParams':{
                                "email": _that.email,
                                "password": _that.password,
                            },
                            'localParams' : {
                                'parameter' : _that
                            }
                        }
                        _that._runLogin(inputJson)
                    }else{
                        _that.handleValidationErrorAdvanced(_that.errors)
                    }
                });
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/components/fxView/admin/login.vue